import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MainCard from 'components/MainCard';
import { isChunkLoadError, reloadOnceForStaleChunk } from 'utils/lazyImport';
import { useShellConfig } from 'contexts/ShellConfigContext';

export default function RouteErrorPage() {
  const { homePath } = useShellConfig();
  const error = useRouteError();
  const { t } = useTranslation();

  const message = error instanceof Error ? error.message : isRouteErrorResponse(error) ? error.statusText : '';
  const chunkStale = isChunkLoadError(error) || isChunkLoadError({ message });

  const handleReload = () => {
    if (chunkStale) {
      reloadOnceForStaleChunk();
      return;
    }
    window.location.reload();
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: 'background.default' }}>
      <MainCard sx={{ maxWidth: 440, width: '100%' }}>
        <Stack spacing={2}>
          <Typography variant="h5">{chunkStale ? t('errors.appUpdatedTitle') : t('errors.pageLoadTitle')}</Typography>
          <Typography variant="body2" color="text.secondary">
            {chunkStale ? t('errors.appUpdatedBody') : t('errors.pageLoadBody')}
          </Typography>
          {chunkStale && (
            <Typography variant="caption" color="text.disabled">
              {t('errors.appUpdatedHint')}
            </Typography>
          )}
          {message ? (
            <Typography variant="caption" color="error" component="pre" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {message}
            </Typography>
          ) : null}
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button variant="contained" onClick={handleReload}>
              {t('errors.reload')}
            </Button>
            <Button variant="outlined" component={Link} to={homePath}>
              {t('errors.goHome')}
            </Button>
          </Stack>
        </Stack>
      </MainCard>
    </Box>
  );
}
